import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import Payout from './Payout';
import messages from '../../../locale/messages';
import { restrictUrls } from '../../../helpers/adminPrivileges';

async function action({ store, intl }) {
  const title = intl.formatMessage(messages.payoutManagementLabel);
  let adminPrivileges = store.getState().adminPrevileges.privileges && store.getState().adminPrevileges.privileges.privileges;

  let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;

  if (!isAdminAuthenticated) {
    return { redirect: '/login' }
  }

  if (!restrictUrls('/siteadmin/manage-payout', adminPrivileges)) {
    return { redirect: '/siteadmin' };
  }

  return {
    title,
    component: (
      <AdminLayout><Payout /></AdminLayout>
    )
  }
}

export default action;
